<template>
  <div class="product-edit-container">
    <el-form :model="form" label-width="100px" label-position="left" ref="productFormRef">
      <!-- 1. 基本信息 -->
      <el-card shadow="never" class="box-card">
        <template #header>
          <div class="card-header"><span>基本信息</span></div>
        </template>

        <el-row :gutter="40">
          <el-col :span="12">
            <el-form-item label="商品标题" required>
              <el-input
                :maxlength="30"
                v-model="form.spuName" placeholder="请输入商品标题" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 问题3解决：分类接口 + 搜索 -->
            <el-form-item label="产品类目" >
              <el-select
                v-model="form.catCode"
                placeholder="请选择或搜索分类"
                filterable
                clearable
                style="width: 100%"
                @change="handleCatChange"
                :loading="catLoading"
              >
                <el-option
                  v-for="item in categoryList"
                  :key="item.catCode"
                  :label="item.catName"
                  :value="item.catCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="商品简介" required class="section-item">
          <el-input
            v-model="form.simpleDesc"
            type="textarea"
            :rows="3"
            placeholder="最少输入10个字符"
            :maxlength="30"
            :minlength="10"
            show-word-limit
          />
        </el-form-item>

        <!-- 问题1解决：使用正常的布局流，移除 margin-top 这种容易引起重叠的操作 -->
        <el-form-item label="商品主图" required class="image-section">
          <div class="image-uploader-wrapper">
            <div class="image-grid">

              <CUpload
                :model-value="form.goodsImgUrlList"
                list-type="image"
                src-type="url"
                accept="image/*"
                :multiple="true"
                :count-limit="9"
                @change="onCompleteHeaderPic"

              />
            </div>
            <div class="tip">建议 800*800，最多9张 ({{form.goodsImgUrlList?.length}}/9)</div>
          </div>
        </el-form-item>

        <el-form-item label="商品详情" class="image-section">
          <div class="image-uploader-wrapper">
            <div class="image-grid">

              <CUpload
                :model-value="form.goodsDetailUrlList"
                list-type="image"
                src-type="url"
                accept="image/*"
                :multiple="true"
                :count-limit="10"
                @change="onCompleteDetailPic"
              />
            </div>
            <div class="tip">详情页展示图，可上传多张</div>
          </div>
        </el-form-item>
      </el-card>

      <!-- 2. 规格与库存 -->
      <el-card shadow="never" class="box-card mt-20">
        <template #header>
          <div class="card-header"><span>价格与库存</span></div>
        </template>

        <div class="spec-manage-box">
          <div class="spec-header-row">
            <span class="label">规格名称：</span>
            <el-input v-model="tempSpecName"
                      :maxlength="10"
                      placeholder="如：净含量" style="width: 240px" />
            <span class="tip-inline">修改名称将更新下方表格列名</span>
          </div>

          <div class="spec-values-row">
            <span class="label">规格值：</span>
            <div class="values-list">
              <div v-for="(val, index) in tempSpecValues" :key="index" class="spec-value-item">
                <el-input
                  v-model="tempSpecValues[index]"
                  placeholder="输入规格"
                  @input="handleSpecValueChange"
                />
                <el-button link type="danger"
                           @click="removeSpecValue(index)" v-if="tempSpecValues.length > 1 && showDeleteBtn(index)" >
                  删除
                </el-button>
              </div>
              <el-button type="primary"
                         v-if="form.skuList.length<10"
                         plain  @click="addSpecValue">添加规格值</el-button>
            </div>
          </div>
        </div>

        <div class="sku-table-wrapper">
          <el-table :data="form.skuList" border stripe>
            <!-- 问题2解决：动态列名由 tempSpecName 决定 -->
            <el-table-column :label="'规格'" min-width="150">
              <template #default="{ row }">
                <el-input v-model="row.skuName" />
              </template>
            </el-table-column>
            <el-table-column label="* 售价" width="150">
              <template #default="{ row }">
                <el-input-number v-model="row.sellingPrice" :precision="2" :min="0" controls-position="right" style="width:100%" />
              </template>
            </el-table-column>
            <el-table-column label="成本价" width="150">
              <template #default="{ row }">
                <el-input-number v-model="row.costPrice" :precision="2" :min="0" controls-position="right" style="width:100%" />
              </template>
            </el-table-column>
            <el-table-column label="* 库存" width="130">
              <template #default="{ row }">
                <el-input-number v-model="row.stockNum" :min="0" :precision="0" controls-position="right" style="width:100%" />
              </template>
            </el-table-column>
            <el-table-column label="SKU编码" min-width="140">
              <template #default="{ row }">
                <el-input
                  disabled
                  v-model="row.skuCode" placeholder="编码" />
              </template>
            </el-table-column>
            <el-table-column label="上架" width="80" align="center">
              <template #default="{ row }">
                <el-switch v-model="row.skuStatus" active-value="grounding" inactive-value="off_shelf" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>

      <!-- 3. 其他设置 -->
      <el-card shadow="never" class="box-card mt-20">
        <el-form-item label="购买限制">
          <el-switch v-model="form.buyLimiter" :active-value="1" :inactive-value="0" />
          <span class="ml-10">{{ form.buyLimiter === 1 ? '已开启限购' : '不限购' }}</span>
          <span v-if="form.buyLimiter === 1" class="limit-box">
             每人
            <span>
              <el-select v-model="form.buyRuleType" placeholder="请选择">
                <el-option label="每日" value="day" />
                <el-option label="累计" value="order_num" />
              </el-select>
            </span>
            限购 <el-input-number v-model="form.buyRuleValue" :min="1"  /> 件
          </span>
        </el-form-item>
      </el-card>

      <div class="form-footer">
        <el-button size="large" @click="handleCancel">取消</el-button>
        <el-button type="primary" size="large" @click="submitForm">确认提交</el-button>
      </div>
    </el-form>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { Plus, Delete, CircleCloseFilled } from '@element-plus/icons-vue';
import {ElMessage, ElMessageBox} from 'element-plus';
import { useCurrentAppInstance } from '@zto/zpage';
import {CUpload} from "@zto/zpage-ui-element/components";

const app = useCurrentAppInstance();

// --- 数据模型 (完全对应后端 SpuInfoCreateReq) ---
let form = reactive({
  spuName: '',
  catCode: '',
  catName: '',
  buyLimiter: 0,
  goodsImgUrlList: [],
  goodsDetailUrlList: [],
  simpleDesc: '',
  skuList: []
});

const showDeleteBtn = (index)=>{
  if (index>(form.skuList.length-1)){
    return true
  }
  return !form.skuList[index].skuCode
}

// 辅助响应式变量
const categoryList = ref([]);
const catLoading = ref(false);
const tempSpecName = ref(''); // 对应 UI 上的规格名
const tempSpecValues = ref(['默认规格']); // 对应 UI 上的规格值数组

function getHashQuery() {
  const hash = window.location.hash || ''
  const queryStr = hash.includes('?') ? hash.split('?')[1] : ''
  return new URLSearchParams(queryStr)
}

// --- 逻辑实现 ---

const queryDetail=async ()=>{
  const params = getHashQuery()
  const id = params.get('id')
  if (id){
    const res = await app.request({
      api: 'pc/goods/detail',
      params: {
        spuCode: id
      }
    });
    res.goodsImgUrlList = res.spuDetailDTO.goodsImgList
    res.goodsDetailUrlList = res.spuDetailDTO.detailImgList
    tempSpecValues.value = res.skuInfoList.map(item=>item.skuName)
    res.skuList =res.skuInfoList
    if (res.goodsBuyRuleDTO.ruleValue){
      res.buyLimiter=1
      res.buyRuleValue = Number.parseInt(res.goodsBuyRuleDTO.ruleValue)
    }
    res.buyRuleType = res.goodsBuyRuleDTO.ruleType
    Object.assign(form, res)
  }
}


function handleCancel(){
  ElMessageBox.confirm(
    '确认离开当前页面吗？',
    '提示',
    {
      confirmButtonText: '是',
      cancelButtonText: '否',
      type: 'warning',
    }
  )
    .then(() => {
      // 👉 点【确定】
      app.router.goBack()
    })
    .catch(() => {
      // 👉 点【取消】或关闭
      ElMessage.info('已取消操作')
    })
}


function onCompleteHeaderPic(t){
  form.goodsImgUrlList = t
}

function onCompleteDetailPic(t){
  form.goodsDetailUrlList = t
}


// 1. 获取分类 (问题3)
const getCategoryList = async () => {
  catLoading.value = true;
  try {
    const res = await app.request({
      api: 'pc/catInfo/list',
      params: { pageSize: 100, pageIndex: 1 }
    });
    categoryList.value = res?.data.filter(item => item.catStatus==='grounding') || [];
  } finally {
    catLoading.value = false;
  }
};

const handleCatChange = (val) => {
  const target = categoryList.value.find(item => item.catCode === val);
  form.catName = target ? target.catName : '';
};

// 2. 规格联动逻辑 (问题2)
const handleSpecValueChange = () => {
  const oldDataMap = new Map();
  form.skuList.forEach(item => oldDataMap.set(item.skuName, item));

  // 自动拓展或减少 skuList
  form.skuList = tempSpecValues.value.map(val => {
    // 尽量保留用户已经输入的售价和库存
    if (oldDataMap.has(val)) return oldDataMap.get(val);

    // 返回符合 SkuInfoCreateReq 的结构
    return {
      skuName: val,
      skuCode: '',
      sellingPrice: undefined,
      costPrice: undefined,
      skuStatus: 'grounding',
      stockNum: undefined,
      originalSkuPrice: undefined
    };
  });
};

const addSpecValue = () => {
  tempSpecValues.value.push('');
  handleSpecValueChange();
};

const removeSpecValue = (index) => {
  tempSpecValues.value.splice(index, 1);
  handleSpecValueChange();
};

// 4. 提交数据
const submitForm = async () => {
  // 校验逻辑
  if (!form.spuName) return ElMessage.warning('请输入标题');
  if (!form.simpleDesc || form.simpleDesc.length <10){
    return ElMessage.warning('产品介绍最少输入10个字符');
  }
  if (!form.goodsImgUrlList.length) return ElMessage.warning('请上传商品主图');
  if (!form.goodsDetailUrlList.length) return ElMessage.warning('请上传商品详情图');
  if (form.skuList.some(s => !s.sellingPrice || !s.stockNum)) {
    return ElMessage.warning('请填写完整的SKU价格和库存');
  }
  if (form.buyLimiter === 0){
    form.buyRuleValue = ''
    form.buyRuleType = ''
  }
  // 深度清理准备提交的数据
  const payload = JSON.parse(JSON.stringify(form));

  // 按照后端 BigDecimal 习惯，确保数字类型正确，skuStatus 是 String
  payload.skuList.forEach(sku => {
    sku.sellingPrice = Number(sku.sellingPrice || 0);
    sku.stockNum = Number(sku.stockNum || 0);
  });

  console.log('提交给后端的最终参数:', payload);

  let apiUrl = 'pc/goods/createSpuInfo'
  if (form.spuCode){
    apiUrl = 'pc/goods/editSpuInfo'
  }
  await app.request({ api: apiUrl, method: 'post', data: payload });
  ElMessage.success('发布成功');
  setTimeout(()=>{
    app.router.back()
  },1000)
};

onMounted(() => {
  getCategoryList();
  handleSpecValueChange(); // 初始生成一行
  queryDetail()
});
</script>

<style scoped>
.product-edit-container {
  background-color: #f0f2f5;
  min-height: 100vh;
}
.box-card {
  border: none;
  border-radius: 4px;
}
.card-header {
  font-weight: bold;
  border-left: 4px solid #409eff;
  padding-left: 10px;
}

/* 解决问题1：彻底重写图片部分，避免重叠 */
.image-section {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
}
.image-uploader-wrapper {
  width: 100%;
}
.image-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.img-preview {
  width: 110px;
  height: 110px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  position: relative;
}
.preview-el-img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.delete-icon {
  position: absolute;
  top: -8px;
  right: -8px;
  color: #f56c6c;
  background: #fff;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
}
.uploader-plus {
  width: 110px;
  height: 110px;
  border: 1px dashed #dcdfe6;
  background: #fafafa;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: border-color 0.2s;
}
.uploader-plus:hover { border-color: #409eff; }
.uploader-text { font-size: 12px; color: #909399; margin-top: 4px; }

.tip { font-size: 12px; color: #909399; margin-top: 8px; }

/* 规格管理样式 */
.spec-manage-box {
  background-color: #f8f9fb;
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #edf0f5;
  margin-bottom: 20px;
}
.spec-header-row, .spec-values-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.label { width: 80px; font-weight: 500; color: #606266; }
.tip-inline { font-size: 12px; color: #909399; margin-left: 15px; }
.values-list {
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.spec-value-item {
  display: flex;
  align-items: center;
  width: 180px;
}

.sku-table-wrapper { margin-top: 15px; }
.limit-box { margin-left: 20px; color: #666; font-size: 14px; }
.mt-20 { margin-top: 20px; }
.ml-10 { margin-left: 10px; }

.form-footer {
  margin-top: 30px;
  padding: 24px;
  background: #fff;
  text-align: center;
  border-radius: 4px;
}
</style>
